import { render, staticRenderFns } from "./BridgingSatuSehat.vue?vue&type=template&id=9c025978&scoped=true&"
import script from "./BridgingSatuSehat.vue?vue&type=script&lang=js&"
export * from "./BridgingSatuSehat.vue?vue&type=script&lang=js&"
import style0 from "./BridgingSatuSehat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BridgingSatuSehat.vue?vue&type=style&index=1&id=9c025978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c025978",
  null
  
)

export default component.exports